// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__1u1YZ","list":"Partners_list__P2bFi","card":"Partners_card__Wzzvq"};